import React, { useState, useEffect } from "react";
import reportAPI from "../../../../api/report";
import { FilterYearMonthType } from "../common/ReportFilters";
import { ButtonExcel } from "../../../../utils/buttonLoadExcel";
import { BarChart, Bar, YAxis, CartesianGrid, Tooltip } from "recharts";
import { BARCHART, FLEXDROPDOWN, STYLEBODY } from "../../../../utils/useStyle";
import { ExcelSideCat } from "../../functions/Report.ExportSideCat";

const ReportSideCat = ({ userDept }) => {
  const [loading, setLoading] = useState(false);
  const [month, setMonth] = useState({
    label: "ทุกเดือน",
    value: "ALL",
  });
  const [year, setYear] = useState({
    label: "ทุกปี",
    value: "ALL",
  });
  const [type, setType] = useState({
    label: "-",
    value: "NONE",
  });

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      const count = payload?.[0]?.value || 0;
      const percentage = ((count * 100) / data.sum_LT).toFixed(1);
      const count2 = payload?.[1]?.value || 0;
      const percentage2 = ((count2 * 100) / data.sum_RT).toFixed(1);

      return (
        <div className="bg-gray-50 text-gray-700 text-sm px-2 py-1 rounded">
          <p className="label">{`Left : ${count} (${percentage}%)`}</p>
          <p className="label">{`Right : ${count2} (${percentage2}%)`}</p>
        </div>
      );
    }

    return null;
  };

  const [data, setData] = useState({
    cat1_LT: 0,
    cat2_LT: 0,
    cat3_LT: 0,
    cat4_LT: 0,
    cat5_LT: 0,
    cat6_LT: 0,
    cat7_LT: 0,
    cat8_LT: 0,

    cat1_RT: 0,
    cat2_RT: 0,
    cat3_RT: 0,
    cat4_RT: 0,
    cat5_RT: 0,
    cat6_RT: 0,
    cat7_RT: 0,
    cat8_RT: 0,
    sum_LT: 0,
    sum_RT: 0,
    sum_LT1RT1: 0,
    sum_LT2RT2: 0,
    sum_LT3RT3: 0,
    sum_LT4RT4: 0,
    sum_LT5RT5: 0,
    sum_LT6RT6: 0,
    sum_LT7RT7: 0,
    sum_LT8RT8: 0,
    sum_All: 0,
    piccCheck: [],
    centralChecl: [],
    missingAll: 0,
    piccMissing: 0,
    centralMissing: 0,
  });

  useEffect(() => {
    // Use backend API instead of frontend processing
    const fetchData = async () => {
      try {
        const response = await reportAPI.getSideCatReport({
          year: String(year?.value),
          type: String(type?.value),
          month: String(month?.value),
          user_department: userDept,
        });

        
        console.log("response", response)
        if (response?.success) {
          setData(response.data);
        }
      } catch (error) {
        console.error("Error fetching side cat report:", error);
      }
    };
    fetchData();
  }, [year, type, month, userDept]);

  const listTable = [
    { name: "Basilic vein", left: data?.cat1_LT, right: data?.cat1_RT },
    { name: "Brachial vein", left: data?.cat2_LT, right: data?.cat2_RT },
    { name: "Cephalic vein", left: data?.cat3_LT, right: data?.cat3_RT },
    {
      name: "Internal jugular vein",
      left: data?.cat4_LT,
      right: data?.cat4_RT,
    },
    { name: "Subclavian vein", left: data?.cat5_LT, right: data?.cat5_RT },
    { name: "Femoral vein", left: data?.cat6_LT, right: data?.cat6_RT },
    { name: "Distal femoral vein", left: data?.cat7_LT, right: data?.cat7_RT },
    { name: "Other", left: data?.cat8_LT, right: data?.cat8_RT },
  ];

  const submitExcelData = {
    "Basilic vein": {
      Lt: data?.cat1_LT,
      Lt_percent: ((data?.cat1_LT * 100) / data?.sum_LT).toFixed(1) + "%",
      Rt: data?.cat1_RT,
      Rt_percent: ((data?.cat1_RT * 100) / data?.sum_RT).toFixed(1) + "%",
      Total: data?.cat1_LT + data?.cat1_RT,
      Total_percent:
        ((data?.sum_LT1RT1 * 100) / data?.sum_All).toFixed(1) + "%",
    },
    "Brachial vein": {
      Lt: data?.cat2_LT,
      Lt_percent: ((data?.cat2_LT * 100) / data?.sum_LT).toFixed(1) + "%",
      Rt: data?.cat2_RT,
      Rt_percent: ((data?.cat2_RT * 100) / data?.sum_RT).toFixed(1) + "%",
      Total: data?.cat2_LT + data?.cat2_RT,
      Total_percent:
        ((data?.sum_LT2RT2 * 100) / data?.sum_All).toFixed(1) + "%",
    },
    "Cephalic vein": {
      Lt: data?.cat3_LT,
      Lt_percent: ((data?.cat3_LT * 100) / data?.sum_LT).toFixed(1) + "%",
      Rt: data?.cat3_RT,
      Rt_percent: ((data?.cat3_RT * 100) / data?.sum_RT).toFixed(1) + "%",
      Total: data?.cat3_LT + data?.cat3_RT,
      Total_percent:
        ((data?.sum_LT3RT3 * 100) / data?.sum_All).toFixed(1) + "%",
    },
    "Internal jugular vein": {
      Lt: data?.cat4_LT,
      Lt_percent: ((data?.cat4_LT * 100) / data?.sum_LT).toFixed(1) + "%",
      Rt: data?.cat4_RT,
      Rt_percent: ((data?.cat4_RT * 100) / data?.sum_RT).toFixed(1) + "%",
      Total: data?.cat4_LT + data?.cat4_RT,
      Total_percent:
        ((data?.sum_LT4RT4 * 100) / data?.sum_All).toFixed(1) + "%",
    },
    "Subclavian vein": {
      Lt: data?.cat5_LT,
      Lt_percent: ((data?.cat5_LT * 100) / data?.sum_LT).toFixed(1) + "%",
      Rt: data?.cat5_RT,
      Rt_percent: ((data?.cat5_RT * 100) / data?.sum_RT).toFixed(1) + "%",
      Total: data?.cat5_LT + data?.cat5_RT,
      Total_percent:
        ((data?.sum_LT5RT5 * 100) / data?.sum_All).toFixed(1) + "%",
    },
    "Femoral vein": {
      Lt: data?.cat6_LT,
      Lt_percent: ((data?.cat6_LT * 100) / data?.sum_LT).toFixed(1) + "%",
      Rt: data?.cat6_RT,
      Rt_percent: ((data?.cat6_RT * 100) / data?.sum_RT).toFixed(1) + "%",
      Total: data?.cat6_LT + data?.cat6_RT,
      Total_percent:
        ((data?.sum_LT6RT6 * 100) / data?.sum_All).toFixed(1) + "%",
    },
    "Distal femoral vein": {
      Lt: data?.cat7_LT,
      Lt_percent: ((data?.cat7_LT * 100) / data?.sum_LT).toFixed(1) + "%",
      Rt: data?.cat7_RT,
      Rt_percent: ((data?.cat7_RT * 100) / data?.sum_RT).toFixed(1) + "%",
      Total: data?.cat7_LT + data?.cat7_RT,
      Total_percent:
        ((data?.sum_LT7RT7 * 100) / data?.sum_All).toFixed(1) + "%",
    },
    Other: {
      Lt: data?.cat8_LT,
      Lt_percent: ((data?.cat8_LT * 100) / data?.sum_LT).toFixed(1) + "%",
      Rt: data?.cat8_RT,
      Rt_percent: ((data?.cat8_RT * 100) / data?.sum_RT).toFixed(1) + "%",
      Total: data?.cat8_LT + data?.cat8_RT,
      Total_percent:
        ((data?.sum_LT8RT8 * 100) / data?.sum_All).toFixed(1) + "%",
    },
    Total: {
      Lt: data?.sum_LT,
      Lt_percent: "100%",
      Rt: data?.sum_RT,
      Rt_percent: "100%",
      Total: data?.sum_LT + data?.sum_RT,
      Total_percent: "100%",
    },
  };

  return (
    <div className="my-20">
      <>
        <div className="flex flex-col gap-4">
          <div className="text-black text-lg font-medium">
            นับหลอดเลือดและข้าง (ซ้ายหรือขวา) ของสายน้ำเกลือที่ใส่
            <div className={STYLEBODY}>
              ของปี "{year.label}" ประเภทสาย "{type.label}"
            </div>
          </div>
          <div className={FLEXDROPDOWN}>
            <FilterYearMonthType
              year={year}
              setYear={setYear}
              type={type}
              setType={setType}
              month={month}
              setMonth={setMonth}
            />
            <ButtonExcel
              onClick={() => {
                ExcelSideCat(submitExcelData, year, type, setLoading);
              }}
              loading={loading}
            />
          </div>
        </div>

        <div className={BARCHART}>
          <BarChart
            width={750}
            height={300}
            data={listTable}
            margin={{
              top: 20,
              bottom: 5,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <YAxis />
            <Tooltip content={<CustomTooltip />} />
            <Bar label={{ fill: "#111827" }} dataKey="left" fill="#fda4af" />
            <Bar label={{ fill: "#111827" }} dataKey="right" fill="#fecdd3" />
          </BarChart>
        </div>
        <div className="grid grid-cols-8 ml-16 mr-18 my-6 text-sm">
          <div className=" -rotate-45 transform-gpu text-center">
            Basilic vein
          </div>
          <div className=" -rotate-45 transform-gpu text-center">
            Brachial vein
          </div>
          <div className=" -rotate-45 transform-gpu text-center">
            Cephalic vein
          </div>
          <div className=" -rotate-45 transform-gpu text-center">
            Internal jugular vein
          </div>
          <div className=" -rotate-45 transform-gpu text-center">
            Subclavian vein
          </div>
          <div className=" -rotate-45 transform-gpu text-center">
            Femoral vein
          </div>
          <div className=" -rotate-45 transform-gpu text-center">
            Distal femoral vein
          </div>
          <div className=" -rotate-45 transform-gpu text-center">Other</div>
        </div>
        <div className="flex justify-center">
          <div className="flex items-center">
            <div className="box-content h-3 w-4 bg-pinkfresh"></div>
            <div className="text-pinkfresh mx-2">left</div>
          </div>
          <div className="flex items-center">
            <div className="box-content h-3 w-4 bg-pinkbold"></div>
            <div className="text-pinkbold mx-2">right</div>
          </div>
        </div>
        <div>
          Missing Data : {data?.missingAll}{" "}
          (มีการใส่สายสำเร็จแต่ไม่ได้ระบุหลอดเลือดที่ใส่สาย)
        </div>
      </>
    </div>
  );
};

export default ReportSideCat;
